"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePhoneNumber = exports.lookupRegionCode = exports.countryCodeOf = void 0;
var awesome_phonenumber_1 = require("awesome-phonenumber");
var compose_1 = __importDefault(require("lodash/fp/compose"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
/**
* Get country code from the 2-character ISO 3166-1 region code.
*
* @example
* ```typescript
* countryCodeOf('CN') // '86'
* countryCodeOf('US') // '1'
* countryCodeOf('something not exist') // undefined
* ```
* */
var countryCodeOf = function (regionCode) {
    return (0, compose_1.default)(function (code) { return (code ? "".concat(code) : undefined); }, awesome_phonenumber_1.getCountryCodeForRegionCode)(regionCode);
};
exports.countryCodeOf = countryCodeOf;
/**
* Lookup the country 2-character ISO 3166-1 region code by given phone number.
*
* @example
* ```typescript
* lookupRegionCode('+12234567890') // 'US'
* lookupRegionCode('+(1) 2234567890') // 'US'
* lookupRegionCode('86') // undefined
* ```
* */
var lookupRegionCode = function (phoneNumber) {
    return (0, compose_1.default)(function (code) { return code !== null && code !== void 0 ? code : undefined; }, function (result) { return ((0, prop_1.default)('valid')(result) ? (0, prop_1.default)('regionCode')(result) : undefined); }, awesome_phonenumber_1.parsePhoneNumber)(phoneNumber);
};
exports.lookupRegionCode = lookupRegionCode;
var toStringOrUndefined = function (code) { return (code ? "".concat(code) : undefined); };
var parsePhoneNumber = function (phoneNumber) {
    var pn = (0, awesome_phonenumber_1.parsePhoneNumber)(phoneNumber);
    var localPhoneNumber = (0, prop_1.default)('number.significant')(pn);
    if (!localPhoneNumber) {
        return {
            regionCode: undefined,
            countryCode: undefined,
            localPhoneNumber: undefined,
        };
    }
    var regionCode = (0, compose_1.default)(toStringOrUndefined, (0, prop_1.default)('regionCode'))(pn);
    var countryCode = (0, compose_1.default)(toStringOrUndefined, (0, prop_1.default)('countryCode'))(pn);
    var correctLocalPhoneNumber = function (significantNumber) {
        var numericOnlyPhoneNumber = phoneNumber.replace(/\D/g, '');
        if (numericOnlyPhoneNumber.slice(countryCode.length) !== significantNumber) {
            return numericOnlyPhoneNumber.slice(countryCode.length);
        }
        return significantNumber;
    };
    return {
        regionCode: regionCode,
        countryCode: countryCode,
        localPhoneNumber: correctLocalPhoneNumber(localPhoneNumber),
    };
};
exports.parsePhoneNumber = parsePhoneNumber;
